import { ref } from "vue";
import { preparedCaption } from "@/composables/useChartUpload";
const preparedInfo = ref({});
/** What the prepare job did to each uploaded document, by link, shared by every component on the page. */
export function usePreparedInfo() {
    const remember = (link, facts) => {
        const known = preparedInfo.value[link];
        const sizeBytes = facts.sizeBytes ?? known?.sizeBytes;
        if (sizeBytes === undefined)
            return;
        preparedInfo.value[link] = {
            sizeBytes,
            droppedPages: facts.droppedPages ?? known?.droppedPages ?? [],
            pageRanges: facts.pageRanges ?? known?.pageRanges,
            originBytes: facts.originBytes ?? known?.originBytes,
            level: facts.level ?? known?.level,
        };
    };
    const captionFor = (link) => preparedInfo.value[link] ? preparedCaption(preparedInfo.value[link]) : null;
    const sizeOf = (link) => preparedInfo.value[link]?.sizeBytes ?? null;
    const factsOf = (link) => preparedInfo.value[link] ?? null;
    return { remember, captionFor, sizeOf, factsOf };
}
